import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchReportDetail({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/admin/report-types`, {
      params: data,
    });

    const { success, message, data: result } = response.data;

    console.log("Success:", success);
    console.log("Message:", message);
    console.log("Data:", result);

    if (success) {
      yield put(actions.fetchReportDetailSuccess(result));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchReportDetailError());
    AntdAlert.error("Something went wrong!");
    console.log("Error in fetch:", error);
  }
}

export function* handleCreateReportDetail({ data }) {
  try {
    console.log(" Creating report with data:", data);
    const payload = {
      title: data.title,
      report_type:data.report_type,
      start_date: data.start_date,
      end_date: data.end_date,
      include_passed_curriculums: data.include_passed_curriculums,
    };

    console.log("Payload to be sent:", payload);

    const response = yield axios.post(
      `${baseURL}/api/v2/admin/report-types`,
      payload
    );

    const { success, message, data: responseData } = response.data;

    if (success) {
      console.log(" Report created successfully:", responseData);
      AntdAlert.success(message || "Report created successfully.");
      yield put(actions.createReportDetailSuccess(responseData));
    } else {
      AntdAlert.error(response.data?.errors?.[0] || "Create failed.");
      yield put(actions.createReportDetailError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.error(" Error during report creation:", error);
    yield put(actions.createReportDetailError());
    AntdAlert.error("Something went wrong while creating.");
    console.error(error);
  }
}

export function* handleUpdateReportDetail({ data }) {
      console.log(" updated report with data:", data);

  try {
    const { id, ...payload } = data;

    const response = yield axios.put(
      `${baseURL}/api/v2/admin/report-types/${id}`,
      payload
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message || "Report updated successfully.");
      yield put(actions.updateReportDetailSuccess(response.data?.data || {}));
    } else {
      AntdAlert.error(message || "Update failed.");
      yield put(actions.updateReportDetailError(response.data?.data || {}));
    }
  } catch (error) {
    yield put(
      actions.updateReportDetailError(error?.response?.data?.data || {})
    );
    AntdAlert.error("Something went wrong while updating.");
    console.error(error?.response);
  }
}

export function* watcherReportDetailSaga() {
  yield takeLatest(constants.FETCH_REPORT_DETAIL, handleFetchReportDetail);
  yield takeLatest(constants.CREATE_REPORT_DETAIL, handleCreateReportDetail);
  yield takeLatest(constants.UPDATE_REPORT_DETAIL, handleUpdateReportDetail);
}
